module.exports = __webpack_public_path__ + "img/attestation_geek_do.d0980e60.png";